/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Combobox } from '@neo4j-ndl/react';

const Component = () => {
  let options = [
    {
      label: 'Option 1 ',
      value: 'option-1',
    },
    { label: 'Option 2', value: 'option-2' },
    {
      label: 'Option 3 has a really, really, really, really, long label',
      value: 'option-3',
    },
    { isDisabled: true, label: 'Option 4', value: 'option-4' },
  ];

  return (
    <Combobox label="Products" options={options} defaultValue={options[0]} />
  );
};

export default Component;
